import React, { useState,useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  FiAlignRight,
  FiXCircle,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import "./Navbarmenu.css";
import { HashLink } from "react-router-hash-link";
import { useMsal } from "@azure/msal-react";
import { baseUrl } from "../Constant";
import axios from "axios";
const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState("c_tech");
  const [selectedStay, setSelectedStay] = useState("");
  const [selectedContact, setSelectedContact] = useState("");
  const [temp,setTemp] = useState("")

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsersForContibution = [
    "aluru.akash",
    "s.rao.masipeddi",
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "vanitadevi.patil",
    "aparna.a.daptardar",
    "lavanya.umesh",
    "arpita.m.singh",
    "uma.rani.battu",
    "reshmi.haridas.m",
    "aayushi.bharti",
    "shramika.s.ambolkar",
    "d.d.choudhary",
    "varsha.a.tyagi",
  ];

  const toggleClass = () => {
    setSelectedOffer("");
    setSelectedStay("");
    setSelectedContact("");
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }

  const [isMenuSubMenusecond, setMenuSubMenusecond] = useState(false);
  const toggleSubmenusecond = () => {
    setMenuSubMenusecond(isMenuSubMenusecond === false ? true : false);
  };
  let boxClassSubMenusecond = ["sub__menussecond"];
  if (isMenuSubMenusecond) {
    boxClassSubMenusecond.push("sub__menus__Activesecond");
  } else {
    boxClassSubMenusecond.push("");
  }

  const [isMenuSubMenuthird, setMenuSubMenuthird] = useState(false);
  const toggleSubmenuthird = () => {
    setMenuSubMenuthird(isMenuSubMenuthird === false ? true : false);
  };
  let boxClassSubMenuthird = ["sub__menusthird"];
  if (isMenuSubMenuthird) {
    boxClassSubMenuthird.push("sub__menus__Activethird");
  } else {
    boxClassSubMenuthird.push("");
  }

  const [isMenuSubMenufourth, setMenuSubMenufourth] = useState(false);
  const toggleSubmenufourth = () => {
    setMenuSubMenufourth(isMenuSubMenufourth === false ? true : false);
  };
  let boxClassSubMenufourth = ["sub__menusfourth"];
  if (isMenuSubMenufourth) {
    boxClassSubMenufourth.push("sub__menus__Activefourth");
  } else {
    boxClassSubMenufourth.push("");
  }
  useEffect(() => {
    const homeUrl = async () => {
      const result = await axios.get(`${baseUrl}/homeUrl`)
      const { data: { Url } } = result
      console.log("test", Url)
      setTemp(Url)
    }
    homeUrl()
  }, [])
  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="header__middle__menus">
          <nav className="main-nav ">
            {/* Responsive Menu Button */}
            {isResponsiveclose === true ? (
              <>
                <span
                  role="button"
                  tabIndex={0}
                  aria-haspopup="true"
                  aria-expanded="false"
                  type="button"
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  {" "}
                  <FiXCircle />{" "}
                </span>
              </>
            ) : (
              <>
                <span
                  role="button"
                  tabIndex={0}
                  aria-haspopup="true"
                  aria-expanded="false"
                  type="button"
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  {" "}
                  <FiAlignRight />{" "}
                </span>
              </>
            )}
            <ul className={boxClass.join(" ")}>
            <li className="menu-item">
                <a
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={() => toggleClass()}
                  href={temp ? temp : ''}
                  target="_blank"
                >
                  L&TT Home
                </a>
              </li>
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/newhome"
                >
                  {" "}
                  Home{" "}
                </NavLink>{" "}
              </li>
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/overview"
                >
                  {" "}
                  Overview{" "}
                </NavLink>{" "}
              </li>
              <li
                onClick={toggleSubmenu}
                className="menu-item sub__menus__arrows"
              >
                <Link
                  className="nav-links"
                  to="/offerings"
                  aria-expanded="false"
                  aria-haspopup="true"
                >
                  {" "}
                  Offerings <FiChevronDown aria-label="Offerings" />{" "}
                </Link>
                <ul className={boxClassSubMenu.join(" ")}>
                  {/* <li className="sub__menus__arrows6">
                    <Link
                      className={
                        selectedOffer === "accprac"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/AccountsandPractices",
                      }}
                      onClick={() => setSelectedOffer("accprac")}
                    >
                      {" "}
                      Accounts and Practices
                    </Link>
                  </li> */}
                  <li className="sub__menus__arrows0">
                    {/* <Link className="nav-links" to="#"> Core Engineering Skills <FiChevronRight /> </Link> */}
                    <Link
                      className={
                        selectedOffer === "c_tech"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "core",
                        menu2: "c_tech",
                      }}
                      onClick={() => setSelectedOffer("c_tech")}
                    >
                      {" "}
                      Entry-level Learning <FiChevronRight />{" "}
                    </Link>
                    <ul className="sub__menus20 offering_sub_menu">
                      <li>
                        <Link
                          className={
                            selectedOffer === "c_tech"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "core",
                            menu2: "c_tech",
                          }}
                          onClick={() => setSelectedOffer("c_tech")}
                        >
                          {" "}
                          Tech Expressway{" "}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="sub__menus__arrows1">
                    {/* <Link className="nav-links" to="#"> Pivot to New <FiChevronRight /> </Link> */}
                    <Link
                      className={
                        selectedOffer === "p_ai"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "pivot",
                        menu2: "p_ai",
                      }}
                      onClick={() => setSelectedOffer("p_ai")}
                    >
                      {" "}
                      Upskilling/Reskilling <FiChevronRight />{" "}
                    </Link>
                    <ul className="sub__menus21 offering_sub_menu">
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_ai"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_ai",
                          }}
                          onClick={() => setSelectedOffer("p_ai")}
                        >
                          {" "}
                          Artificial Intelligence (AI){" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_automation"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_automation",
                          }}
                          onClick={() => setSelectedOffer("p_automation")}
                        >
                          {" "}
                          Automation (RPA){" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_architect"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_architect",
                          }}
                          onClick={() => setSelectedOffer("p_architect")}
                        >
                          {" "}
                          Automation Architect and ARC{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_cloud"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_cloud",
                          }}
                          onClick={() => setSelectedOffer("p_cloud")}
                        >
                          {" "}
                          Cloud{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_custom"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_custom",
                          }}
                          onClick={() => setSelectedOffer("p_custom")}
                        >
                          {" "}
                          Custom Engineering{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_eai"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_eai",
                          }}
                          onClick={() => setSelectedOffer("p_eai")}
                        >
                          {" "}
                          EAI{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_intelligent"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_intelligent",
                          }}
                          onClick={() => setSelectedOffer("p_intelligent")}
                        >
                          {" "}
                          E&IT{" "}
                        </Link>
                      </li>
                      {/* <li>
                        <Link className={selectedOffer === 'p_enterprice' ? "nav-links1 selectedOffer" : "nav-links1"} to={{ pathname: '/offerings', menu1: 'pivot', menu2: 'p_enterprice' }} onClick={() => setSelectedOffer('p_enterprice')}> Enterprise Data Platforms & Data Analytics </Link>
                      </li> */}
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_infrastructure"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_infrastructure",
                          }}
                          onClick={() => setSelectedOffer("p_infrastructure")}
                        >
                          {" "}
                          Infrastructure Engineering{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_innovation"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_innovation",
                          }}
                          onClick={() => setSelectedOffer("p_innovation")}
                        >
                          {" "}
                          Innovation and Human Skills{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_interactive"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_interactive",
                          }}
                          onClick={() => setSelectedOffer("p_interactive")}
                        >
                          {" "}
                          Interactive{" "}
                        </Link>
                      </li>
                      {/* <li>
                        <Link className={selectedOffer === 'p_ixo' ? "nav-links1 selectedOffer" : "nav-links1"} to={{ pathname: '/offerings', menu1: 'pivot', menu2: 'p_ixo' }} onClick={() => setSelectedOffer('p_ixo')}> IXO Academy </Link>
                      </li> */}
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_quality"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_quality",
                          }}
                          onClick={() => setSelectedOffer("p_quality")}
                        >
                          {" "}
                          Quality Engineering{" "}
                        </Link>
                      </li>
                      {/* <li>
                        <Link className={selectedOffer === 'p_salesforce' ? "nav-links1 selectedOffer" : "nav-links1"} to={{ pathname: '/offerings', menu1: 'pivot', menu2: 'p_salesforce' }} onClick={() => setSelectedOffer('p_salesforce')}> Salesforce </Link>
                      </li> */}
                      <li>
                        <Link
                          className={
                            selectedOffer === "p_security"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "pivot",
                            menu2: "p_security",
                          }}
                          onClick={() => setSelectedOffer("p_security")}
                        >
                          {" "}
                          Security{" "}
                        </Link>
                      </li>
                      {/* <li>
                        <Link className={selectedOffer === 'p_tech' ? "nav-links1 selectedOffer" : "nav-links1"} to={{ pathname: '/offerings', menu1: 'pivot', menu2: 'p_tech' }} onClick={() => setSelectedOffer('p_tech')}> Tech Leap </Link>
                      </li> */}
                    </ul>
                  </li>
                  <li className="sub__menus__arrows2">
                    {/* <Link className="nav-links" to="#"> Lead Change <FiChevronRight /> </Link> */}
                    <Link
                      className={
                        selectedOffer === "l_technology"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "lead",
                        menu2: "l_technology",
                      }}
                      onClick={() => setSelectedOffer("l_technology")}
                    >
                      {" "}
                      Executive Enablement <FiChevronRight />{" "}
                    </Link>
                    <ul className="sub__menus22 offering_sub_menu">
                      <li>
                        <Link
                          className={
                            selectedOffer === "l_technology"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "lead",
                            menu2: "l_technology",
                          }}
                          onClick={() => setSelectedOffer("l_technology")}
                        >
                          {" "}
                          Technology{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "l_human"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "lead",
                            menu2: "l_human",
                          }}
                          onClick={() => setSelectedOffer("l_human")}
                        >
                          {" "}
                          Innovation & Human Skills{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "l_design"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "lead",
                            menu2: "l_design",
                          }}
                          onClick={() => setSelectedOffer("l_design")}
                        >
                          {" "}
                          Delivery{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "l_aspirational"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "lead",
                            menu2: "l_aspirational",
                          }}
                          onClick={() => setSelectedOffer("l_aspirational")}
                        >
                          {" "}
                          Specializations{" "}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="sub__menus__arrows3">
                    {/* <Link className="nav-links" to="#"> Deliver Excellence <FiChevronRight /> </Link> */}
                    <Link
                      className={
                        selectedOffer === "d_dlf"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "deliver",
                        menu2: "d_dlf",
                      }}
                      onClick={() => setSelectedOffer("d_dlf")}
                    >
                      {" "}
                      Delivery Learning <FiChevronRight />{" "}
                    </Link>
                    <ul className="sub__menus23 offering_sub_menu">
                      <li>
                        <Link
                          className={
                            selectedOffer === "d_dlf"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "deliver",
                            menu2: "d_dlf",
                          }}
                          onClick={() => setSelectedOffer("d_dlf")}
                        >
                          {" "}
                          DLF{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "d_delivery"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "deliver",
                            menu2: "d_delivery",
                          }}
                          onClick={() => setSelectedOffer("d_delivery")}
                        >
                          {" "}
                          Delivery{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "d_agile"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "deliver",
                            menu2: "d_agile",
                          }}
                          onClick={() => setSelectedOffer("d_agile")}
                        >
                          {" "}
                          Agile{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "d_devops"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "deliver",
                            menu2: "d_devops",
                          }}
                          onClick={() => setSelectedOffer("d_devops")}
                        >
                          {" "}
                          DevOps{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "d_sre"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "deliver",
                            menu2: "d_sre",
                          }}
                          onClick={() => setSelectedOffer("d_sre")}
                        >
                          {" "}
                          SRE{" "}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="sub__menus__arrows4">
                    {/* <Link className="nav-links" to="#"> Force Multiplier <FiChevronRight /> </Link> */}
                    <Link
                      className={
                        selectedOffer === "f_inclusion"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "force",
                        menu2: "f_inclusion",
                      }}
                      onClick={() => setSelectedOffer("f_inclusion")}
                    >
                      {" "}
                      Strategic Programs <FiChevronRight />{" "}
                    </Link>
                    <ul className="sub__menus24 offering_sub_menu">
                      <li>
                        <Link
                          className={
                            selectedOffer === "f_inclusion"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "force",
                            menu2: "f_inclusion",
                          }}
                          onClick={() => setSelectedOffer("f_inclusion")}
                        >
                          {" "}
                          Inclusion and Diversity{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "f_sustain"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "force",
                            menu2: "f_sustain",
                          }}
                          onClick={() => setSelectedOffer("f_sustain")}
                        >
                          {" "}
                          Sustainability{" "}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="sub__menus__arrows5">
                    <Link
                      className={
                        selectedOffer === "fs_custom"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "fullstack",
                        menu2: "fs_custom",
                      }}
                      onClick={() => setSelectedOffer("fs_custom")}
                    >
                      {" "}
                      Full Stack Programs <FiChevronRight />{" "}
                    </Link>
                    <ul className="sub__menus25 offering_sub_menu">
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_custom"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_custom",
                          }}
                          onClick={() => setSelectedOffer("fs_custom")}
                        >
                          {" "}
                          Custom Engineering{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_cloud"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_cloud",
                          }}
                          onClick={() => setSelectedOffer("fs_cloud")}
                        >
                          {" "}
                          Cloud{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_data"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_data",
                          }}
                          onClick={() => setSelectedOffer("fs_data")}
                        >
                          {" "}
                          Data{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_eai"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_eai",
                          }}
                          onClick={() => setSelectedOffer("fs_eai")}
                        >
                          {" "}
                          EAI{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_infrastructure"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_infrastructure",
                          }}
                          onClick={() => setSelectedOffer("fs_infrastructure")}
                        >
                          {" "}
                          Infrastructure Engineering{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_interactive"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_interactive",
                          }}
                          onClick={() => setSelectedOffer("fs_interactive")}
                        >
                          {" "}
                          Interactive{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_quality"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_quality",
                          }}
                          onClick={() => setSelectedOffer("fs_quality")}
                        >
                          {" "}
                          Quality Engineering{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "fs_sap"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "fullstack",
                            menu2: "fs_sap",
                          }}
                          onClick={() => setSelectedOffer("fs_sap")}
                        >
                          {" "}
                          SAP{" "}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="sub__menus__arrows6">
                    <Link
                      className={
                        selectedOffer === "t_talent"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "talent",
                        menu2: "t_talent",
                      }}
                      onClick={() => setSelectedOffer("t_talent")}
                    >
                      {" "}
                      Talent Academies{" "}
                    </Link>
                  </li>
                  <li className="sub__menus__arrows6">
                    <Link
                      className={
                        selectedOffer === "f_certiprocess"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "certifications",
                        menu2: "f_certiprocess",
                      }}
                      onClick={() => setSelectedOffer("f_certiprocess")}
                    >
                      {" "}
                      Certifications <FiChevronRight />{" "}
                    </Link>
                    <ul className="sub__menus26 offering_sub_menu">
                      <li>
                        <Link
                          className={
                            selectedOffer === "f_certiprocess"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "certifications",
                            menu2: "f_certiprocess",
                          }}
                          onClick={() => setSelectedOffer("f_certiprocess")}
                        >
                          {" "}
                          Certification Process{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            selectedOffer === "f_externalcerti"
                              ? "nav-links1 selectedOffer"
                              : "nav-links1"
                          }
                          to={{
                            pathname: "/offerings",
                            menu1: "certifications",
                            menu2: "f_externalcerti",
                          }}
                          onClick={() => setSelectedOffer("f_externalcerti")}
                        >
                          {" "}
                          External certifications{" "}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="sub__menus__arrows6">
                    <Link
                      className={
                        selectedOffer === "w_new"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to={{
                        pathname: "/offerings",
                        menu1: "whats",
                        menu2: "w_new",
                      }}
                      onClick={() => setSelectedOffer("w_new")}
                    >
                      {" "}
                      Whats New{" "}
                    </Link>
                  </li>

                  {/* <li className="sub__menus__arrows4 offering_sub_menu1">
                    <Link className={selectedOffer === 'build' ? "nav-links1 selectedOffer" : "nav-links1"} to={{ pathname: '/offerings', menu1: 'build', menu2: '' }} onClick={() => setSelectedOffer('build')}> Certifications </Link>
                  </li> */}
                </ul>
              </li>
              {/* <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/stayknow"
                    >
                      {" "}
                      Stay in the know{" "}
                    </NavLink>{" "}
                  </li> */}
              <li
                onClick={toggleSubmenusecond}
                className="menu-item sub__menus__arrows"
              >
                <Link
                  className="nav-links"
                  to="/stayknow"
                  aria-expanded="false"
                  aria-haspopup="true"
                >
                  {" "}
                  Stay in the Know{" "}
                  <FiChevronDown aria-label="Stay in the Know" />{" "}
                </Link>
                <ul className={boxClassSubMenusecond.join(" ")}>
                  {/* <li className='stay_in_the_know'><Link className={selectedOffer === 'eCatalogs' ? "nav-links selectedOffer" : "nav-links"} to={{ pathname: '/stayknow', menu1: 'eCatalogs', menu2: '' }} onClick={() => setSelectedOffer('eCatalogs')}> LKM eCatalogs </Link></li>
                  <li className='stay_in_the_know'> <Link className={selectedOffer === 'Calendar' ? "nav-links selectedOffer" : "nav-links"} to={{ pathname: '/stayknow', menu1: 'Calendar', menu2: '' }} onClick={() => setSelectedOffer('Calendar')}> LKM Calendar </Link> </li>
                  <li className='stay_in_the_know'> <Link className={selectedOffer === 'Paths' ? "nav-links selectedOffer" : "nav-links"} to={{ pathname: '/stayknow', menu1: 'Paths', menu2: '' }} onClick={() => setSelectedOffer('Paths')}> Learning Paths </Link></li>
                  <li className='stay_in_the_know'><Link className={selectedOffer === 'Events' ? "nav-links selectedOffer" : "nav-links"} to={{ pathname: '/stayknow', menu1: 'Events', menu2: '' }} onClick={() => setSelectedOffer('Events')}> Learning Events </Link>  </li>
                  <li className='stay_in_the_know'><Link className={selectedOffer === 'digital' ? "nav-links selectedOffer" : "nav-links"} to={{ pathname: '/stayknow', menu1: 'digital', menu2: '' }} onClick={() => setSelectedOffer('digital')}> Digital Learning Platforms </Link>  </li> */}
                  <li className="stay_in_the_know">
                    <a
                      className={
                        selectedStay === "lkm_calendar"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      // to={{ pathname: 'https://atci.lkm.accenture.com/learning-calendar', stay: 'lkm_calendar'}} rel='noreferrer'
                      href="https://atci.lkm.accenture.com/learning-calendar/"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => {
                        setSelectedStay("lkm_calendar");
                        setSelectedContact("");
                      }}
                    >
                      {" "}
                      L&TT Calendar{" "}
                    </a>
                  </li>
                  <li className="stay_in_the_know">
                    <a
                      className={
                        selectedStay === "lkm_eCatalogs"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      href="https://atci.lkm.accenture.com/LKM-eCatalog/home"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => {
                        setSelectedStay("lkm_eCatalogs");
                        setSelectedContact("");
                      }}
                    >
                      {" "}
                      L&TT eCatalogs{" "}
                    </a>
                  </li>
                  <li className="stay_in_the_know">
                    <HashLink
                      className={
                        selectedStay === "l_events"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to="/stayknow#learning-events"
                      onClick={() => {
                        setSelectedStay("l_events");
                        setSelectedContact("");
                      }}
                    >
                      {" "}
                      Learning Events{" "}
                    </HashLink>
                  </li>
                  {/* <li className='stay_in_the_know'><HashLink className={selectedStay === 'd_learning' ? 'nav-links selectedOffer' : 'nav-links'} to='/stayknow#digital-learning-platforms' onClick={() => {setSelectedStay('d_learning');setSelectedContact('');}}> Digital Learning Platforms </HashLink></li> */}
                  <li className="stay_in_the_know">
                    <HashLink
                      className={
                        selectedStay === "l_specialization"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to="/stayknow#learning-paths/specializations"
                      onClick={() => {
                        setSelectedStay("l_specialization");
                        setSelectedContact("");
                      }}
                    >
                      {" "}
                      Learning Paths/Specializations{" "}
                    </HashLink>
                  </li>
                  {/* <li className='stay_in_the_know'><HashLink className={selectedStay === 'l_infrastructure' ? 'nav-links selectedOffer' : 'nav-links'} to='/stayknow#learning-infrastructure' onClick={() => {setSelectedStay('l_infrastructure');setSelectedContact('');}}> Learning Infrastructure </HashLink></li> */}
                </ul>
              </li>

              {/* <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/AccountsandPractices"
                >
                  {" "}
                  Accounts and Practices{" "}
                </NavLink>{" "}
              </li> */}
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/Endorsements"
                >
                  {" "}
                  Endorsements{" "}
                </NavLink>{" "}
              </li>
              {/* <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/ServiceOfferings"
                >
                  {" "}
                  Service Offerings{" "}
                </NavLink>{" "}
              </li> */}
              {/* <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/key-resources"
                    >
                      {" "}
                      Key Resources{" "}
                    </NavLink>{" "}
                  </li> */}
              {/* <li onClick={toggleSubmenuthird} className="menu-item sub__menus__arrows" > <Link className="nav-links" to="/OurLeads"> Connect <FiChevronDown /> </Link>
                <ul className={boxClassSubMenuthird.join(' ')} >
                  <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/OurLeads"> Our Leads </NavLink> </li>
                  <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/Endorsements"> Endorsements </NavLink> </li>
                  <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/awards"> Awards and Recognitions </NavLink> </li>
                </ul>
              </li> */}
              {/* <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/learning-calendar"
                >
                  {" "}
                  Learning Calendar{" "}
                </NavLink>{" "}
              </li> */}
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/awards"
                >
                  {" "}
                  Awards{" "}
                </NavLink>{" "}
              </li>
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/OurLeads"
                >
                  {" "}
                  Our Leads{" "}
                </NavLink>{" "}
              </li>
              {/* <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/FacultyCommunityHub"
                >
                  {" "}
                  Faculty Community HUB{" "}
                </NavLink>{" "}
              </li> */}
              <li
                onClick={toggleSubmenufourth}
                className="menu-item sub__menus__arrows"
              >
                <Link
                  className="nav-links"
                  to="/contact"
                  aria-expanded="false"
                  aria-haspopup="true"
                >
                  {" "}
                  Contact <FiChevronDown aria-label="Contact" />{" "}
                </Link>
                <ul className={boxClassSubMenufourth.join(" ")}>
                  {/* <li className='stay_in_the_know'><a className={selectedContact === 'training_request' ? 'nav-links selectedOffer' : 'nav-links'} href='https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest' target='_blank' rel='noreferrer' onClick={() => {setSelectedContact('training_request');setSelectedStay('');}}> Request for Training </a></li> */}
                  <li className="stay_in_the_know">
                    <HashLink
                      className={
                        selectedContact === "lkm_contribute"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      to="/contact#contribute-to-LKM"
                      onClick={() => {
                        setSelectedContact("lkm_contribute");
                        setSelectedStay("");
                      }}
                    >
                      {" "}
                      Contribute to L&TT{" "}
                    </HashLink>
                  </li>
                  <li className="stay_in_the_know">
                    <a
                      className={
                        selectedContact === "contact_request"
                          ? "nav-links selectedOffer"
                          : "nav-links"
                      }
                      href="https://ts.accenture.com/sites/LKMTools/LKMSurveys/23Sep21/LKM%20Content%20Design%20and%20Development/SitePages/Home.aspx"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => {
                        setSelectedContact("contact_request");
                        setSelectedStay("");
                      }}
                    >
                      {" "}
                      Request for Content Creation{" "}
                    </a>
                  </li>
                </ul>
              </li>
              {allowedUsersForContibution.includes(loggedInEnterpriseId) ? (
                <li
                  onClick={toggleSubmenufourth}
                  className="menu-item sub__menus__arrows"
                >
                  <Link className="nav-links">
                    {" "}
                    Admin <FiChevronDown />{" "}
                  </Link>
                  <ul className={boxClassSubMenufourth.join(" ")}>
                    <li className="stay_in_the_know">
                      <a
                        href="/contribute"
                        target="_blank"
                        rel="noreferrer"
                        className="nav-links selectedOffer"
                      >
                        {" "}
                        L&TT Contributors{" "}
                      </a>
                    </li>
                    <li className="stay_in_the_know">
                      <a
                        href="/feedback"
                        target="_blank"
                        rel="noreferrer"
                        className="nav-links"
                      >
                        {" "}
                        L&TT Feedbacks{" "}
                      </a>
                    </li>
                    <li className="stay_in_the_know">
                      <NavLink
                        activeClassName="is-active"
                        className="nav-links"
                        onClick={toggleClass}
                        to={`/analytics`}
                      >
                        Analytics
                      </NavLink>
                    </li>
                  </ul>
                </li>
              ) : (
                ""
              )}
              {/* <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/gallery"
                    >
                      {" "}
                      Gallery{" "}
                    </NavLink>{" "}
                  </li> */}
              {/* <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/share"
                >
                  {" "}
                  Share Your Experience{" "}
                </NavLink>{" "}
              </li> */}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
